import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M5.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5.5 14a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M17 8.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M18.5 14a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M10.5 8.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M12 14a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3" />
  </>
);

const Handle = Icon('handle', svgContents);

export default Handle;
